import ENV from "cc-frontend/config/environment"
import UnsplashReact, { InsertIntoApplicationUploader } from "unsplash-react"

interface Props {
  onPhotoSelected: (imageUrl: string) => void
}

export default function UnsplashUpload({ onPhotoSelected }: Props) {
  return (
    <UnsplashReact
      accessKey={ENV.UNSPLASH_ACCESS_KEY}
      applicationName="cc-frontend"
      Uploader={InsertIntoApplicationUploader}
      preferredSize={{ width: 2560, height: 1440 }}
      photoRatio={16 / 9}
      columns={3}
      onFinishedUploading={onPhotoSelected}
    />
  )
}
